export const AIRTABLE_API_KEY = 'keyIwsYkLidTpJSWL'
export const AIRTABLE_BASE_ID = 'appZnzYNUwLRhmNaq'